<template>
  <crud-form
    v-model="payload"
    :page-title="getPageTitle"
    :navigate-back-route="'group.list'"
    :navigate-page-after-save="'group.list'"
    :request-class="requestClass"
    :total-group="2"
    :override-edit-payload="makeRequestBeforeEdit"
  >
    <template slot="group-1">
      <produto-group-content
        :payload="payload"
        :edit-mode="getGroupid"
        :image="image"
        :preload="preload"
      />
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import ProdutoGroupRequest from './ProdutoGroupRequest';
import ProdutoGroupContent from './ProdutoGroupContent.vue';

export default {
  name: 'ProdutoGroupForm',
  components: {
    CrudForm, ProdutoGroupContent,
  },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    isActive: null,
    requestClass: ProdutoGroupRequest,
    payload: {
      descricao: '',
      nomProdutoAgrupamento: '',
      ordemExibicao: '',
      id: '',
    },
    image: {
      name: '',
      file: '',
      rawFile: '',
    },
    preload: '',
  }),
  computed: {
    getGroupid() {
      return this.$route.params.id;
    },
    getPageTitle() {
      return this.getGroupid ? 'Editar agrupamento' : 'Adicionar agrupamento';
    },
  },
  watch: {
    'payload.id': {
      handler(value) {
        if (value) {
          this.isActive = value;
        }
      },
    },
    'image.name': {
      handler(value) {
        if (!value) {
          this.image = {
            name: '',
            file: '',
            rawFile: '',
          };
        }
        this.preload = this.image.file;
      },
    },
  },
  methods: {
    makeRequestBeforeEdit() {
      this.makeUploadFile();
      return { ...this.payload };
    },
    makeUploadFile() {
      this.verifyImageContentAnRequest();
    },
    verifyImageContentAnRequest() {
      if (this.image.name) {
        this.requestClass.upload(this.image.rawFile[0], this.payload.id)
          .catch(({ response }) => {
            this.showMessageError(response.data.message);
          });
      }
    },
    showMessageError(message) {
      this.showErrorToast({
        text: message || 'Falha em fazer upload de imagem',
      });
    },
  },
};
</script>
